/**
 * StoreListPresenter
 * --
 */
import React, { useEffect, useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  TabMenu,
  Tabs,
  HtmlContent,
  Descriptions,
  Collapse,
} from 'components';
import { Input, Button, Avatar, Calendar } from 'antd';
import moment from 'moment';
import { stringToMoneyFormat } from 'utils';

let tabItems = [];
for (let i = 0; i < 10; i++) {
  tabItems.push({
    key: `${i}`,
    label: `JM 커피점 ${i}`,
  });
}

const StoreListPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [selectedStore, setSelectedStore] = useState(tabItems[0]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [tabKey, setTabKey] = useState(1);

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
    tabTitle: {
      fontSize: 14,
      fontWeight: 600,
      color: '#404040',
    },
  };

  /* ===== FUNCTION ===== */
  /**
   * 탭별 렌더링
   * --
   */
  const renderTabView = () => {
    const view = {
      1: (
        <Row>
          <Col x={6}>
            <Content maxWidth={'100%'} padding={10}>
              <h4 style={{ ...styles.tabTitle, marginBottom: 10 }}>
                메뉴별 판매순위
              </h4>
              <div
                style={{
                  background: '#F4F4F4',
                  border: '1px solid #E6E6E6',
                  padding: '7px 10px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div
                    style={{ color: '#B9B9B9', fontSize: 12, fontWeight: 500 }}
                  >
                    메뉴명
                  </div>
                  <div
                    style={{ color: '#B9B9B9', fontSize: 12, fontWeight: 500 }}
                  >
                    판매수량
                  </div>
                </div>
                {new Array(10).fill(null).map((_item, _index) => (
                  <div
                    key={`item_${_index}`}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      paddingTop: 10,
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        flex: 1,
                        fontSize: 16,
                        fontWeight: 500,
                        color: '#6E6E6E',
                        lineHeight: '150%',
                      }}
                    >
                      <span
                        style={{
                          width: 20,
                          textAlign: 'right',
                          marginRight: 10,
                        }}
                      >
                        {_index + 1}.
                      </span>
                      <p>메뉴{_index + 1}</p>
                    </div>
                    <div
                      style={{
                        fontSize: 16,
                        fontWeight: 500,
                        color: '#6E6E6E',
                      }}
                    >
                      {1000 - _index}
                    </div>
                  </div>
                ))}
              </div>
              <Button
                type="primary"
                style={{
                  background: 'var(--primary-color)',
                  width: '100%',
                  marginTop: 10,
                }}
              >
                전체 판매내역 보기
              </Button>
            </Content>
          </Col>
          <Col x={18}>
            <Content maxWidth={'100%'} padding={10}>
              <h4 style={{ ...styles.tabTitle }}>일별 판매량</h4>
              <Calendar headerRender={() => {}} />
            </Content>
          </Col>
        </Row>
      ),
      2: (
        <Row>
          <Col x={8}>
            <Content maxWidth={'100%'} padding={10}>
              <h4 style={{ ...styles.tabTitle }}>위치정보</h4>
              <div>
                <Avatar shape="square" size={300} style={{ width: '100%' }} />
              </div>
              <p
                style={{
                  textAlign: 'center',
                  marginTop: 10,
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#898989',
                }}
              >
                클릭하여 큰 이미지 보기
              </p>
            </Content>
          </Col>
          <Col x={16}>
            <Content maxWidth={'100%'} padding={10}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 10,
                }}
              >
                <h4 style={{ ...styles.tabTitle }}>기본정보</h4>
                <Button
                  type="primary"
                  style={{ background: 'var(--primary-color)' }}
                >
                  편집
                </Button>
              </div>
              <Descriptions
                align="left"
                items={[
                  {
                    key: `1`,
                    label: '매장명',
                    children: `${selectedStore.label}`,
                  },
                  {
                    key: `2`,
                    label: '사업자등록번호',
                    children: '000-00-00000',
                  },
                  {
                    key: `3`,
                    label: '등록일',
                    children: moment().format('YYYY년 MM월 DD일'),
                  },
                  {
                    key: `4`,
                    label: '대표자',
                    children: '홍길동',
                  },
                  {
                    key: `5`,
                    label: '주소',
                    children: '서울특별시 어쩌고 저쩌고길 123(111111)',
                    span: 2,
                  },
                  {
                    key: `6`,
                    label: '전화번호',
                    children: '02-123-1234 / 010-1234-1234',
                    span: 2,
                  },
                  {
                    key: `7`,
                    label: '메뉴 수',
                    children: '24개',
                  },
                  {
                    key: `8`,
                    label: '직원 수',
                    children: '13명',
                  },
                  {
                    key: `9`,
                    label: '영업시간',
                    children: (
                      <>
                        <HtmlContent
                          content={`<p>월: 10:00~21:00</p><p>화: 10:00~21:00</p><p>수: 10:00~21:00</p><p>목: 10:00~21:00</p><p>금: 10:00~24:00</p><p>토/일: 10:00~24:00</p><p>공휴일: 10:00~21:00</p>`}
                          style={{ textAlign: 'left', padding: '20px 0' }}
                        />
                      </>
                    ),
                  },
                ]}
              />
            </Content>
          </Col>
        </Row>
      ),
      3: (
        <Row>
          <Col x={6}>
            <Content maxWidth={'100%'} padding={0}>
              <Content
                maxWidth={'100%'}
                padding={0}
                backgroundColor="#FAFAFA"
                style={{ height: 800, overflow: 'auto' }}
              >
                <Collapse title="음료">
                  {new Array(10).fill(null).map((_item, _index) => (
                    <div
                      key={`product_${_index}`}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: 8,
                        cursor: 'pointer',
                        border:
                          selectedItem === _index
                            ? '1px solid #2394E4'
                            : '1px solid #EFEFEF',
                        borderBottom:
                          selectedItem === _index
                            ? '1px solid #2394E4'
                            : '1px solid #DFDFDF',
                        background:
                          selectedItem === _index
                            ? 'rgba(28, 107, 244, 0.3)'
                            : '#EFEFEF',
                      }}
                      onClick={() => setSelectedItem(_index)}
                    >
                      <div>
                        <Avatar shape="square" size={30} />
                      </div>
                      <div style={{ paddingLeft: 7 }}>
                        <h4>음료{_index + 1}</h4>
                        <p>5,000원</p>
                      </div>
                    </div>
                  ))}
                </Collapse>
                <Collapse title="디저트">
                  {new Array(10).fill(null).map((_item, _index) => (
                    <div
                      key={`product_${_index}`}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: 8,
                        cursor: 'pointer',
                        border:
                          selectedItem === _index
                            ? '1px solid #2394E4'
                            : '1px solid #EFEFEF',
                        borderBottom:
                          selectedItem === _index
                            ? '1px solid #2394E4'
                            : '1px solid #DFDFDF',
                        background:
                          selectedItem === _index
                            ? 'rgba(28, 107, 244, 0.3)'
                            : '#EFEFEF',
                      }}
                      onClick={() => setSelectedItem(_index)}
                    >
                      <div>
                        <Avatar shape="square" size={30} />
                      </div>
                      <div style={{ paddingLeft: 7 }}>
                        <h4>디저트{_index + 1}</h4>
                        <p>5,000원</p>
                      </div>
                    </div>
                  ))}
                </Collapse>
              </Content>
              <div>
                <Button
                  style={{
                    width: '50%',
                    borderRadius: 0,
                  }}
                >
                  카테고리 추가
                </Button>
                <Button
                  type="primary"
                  style={{
                    width: '50%',
                    background: 'var(--primary-color)',
                    borderRadius: 0,
                  }}
                >
                  메뉴 추가
                </Button>
              </div>
            </Content>
          </Col>
          <Col x={18}>
            <Content maxWidth={'100%'} padding={10}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 10,
                }}
              >
                <h4 style={{ ...styles.tabTitle }}>메뉴정보</h4>
                <Button
                  type="primary"
                  style={{ background: 'var(--primary-color)' }}
                >
                  편집
                </Button>
              </div>
              <Descriptions
                align="left"
                items={[
                  {
                    key: `1`,
                    label: '메뉴명',
                    children: '아메리카노(Ice)',
                  },
                  {
                    key: `2`,
                    label: '메뉴번호',
                    children: '0000000000',
                  },
                  {
                    key: `3`,
                    label: '단가',
                    children: stringToMoneyFormat(5000, '원'),
                  },
                  {
                    key: `4`,
                    label: '대표자',
                    children: '홍길동',
                  },
                  {
                    key: `5`,
                    label: '비고',
                    children: '-',
                    span: 2,
                  },
                  {
                    key: `6`,
                    label: '기타옵션',
                    children: '-',
                    span: 2,
                  },
                  {
                    key: `7`,
                    label: '이미지',
                    children: (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          flexWrap: 'wrap',
                          paddingBottom: 100,
                        }}
                      >
                        <Button
                          style={{
                            width: 53,
                            height: 53,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            margin: '20px 8px 8px 0px',
                          }}
                        >
                          + 추가
                        </Button>
                        {new Array(3).fill(null).map((_, _index) => (
                          <Avatar
                            key={`img_${_index}`}
                            size={53}
                            shape="square"
                            style={{ margin: '20px 8px 8px 0px' }}
                          />
                        ))}
                      </div>
                    ),
                  },
                ]}
              />
            </Content>
          </Col>
        </Row>
      ),
      4: (
        <Row>
          <Col x={6}>
            <Content maxWidth={'100%'} padding={0}>
              <Content
                maxWidth={'100%'}
                padding={0}
                backgroundColor="#FAFAFA"
                style={{ height: 800, overflow: 'auto' }}
              >
                {new Array(10).fill(null).map((_item, _index) => (
                  <div
                    key={`product_${_index}`}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: 8,
                      cursor: 'pointer',
                      border:
                        selectedItem === _index
                          ? '1px solid #2394E4'
                          : '1px solid #EFEFEF',
                      borderBottom:
                        selectedItem === _index
                          ? '1px solid #2394E4'
                          : '1px solid #DFDFDF',
                      background:
                        selectedItem === _index
                          ? 'rgba(28, 107, 244, 0.3)'
                          : '#EFEFEF',
                    }}
                    onClick={() => setSelectedItem(_index)}
                  >
                    <div>
                      <Avatar shape="square" size={30} />
                    </div>
                    <div style={{ paddingLeft: 7 }}>
                      <h4>직원{_index + 1}</h4>
                      <p>바리스타</p>
                    </div>
                  </div>
                ))}
              </Content>
              <div>
                <Button
                  type="primary"
                  style={{
                    width: '100%',
                    background: 'var(--primary-color)',
                    borderRadius: 0,
                  }}
                >
                  직원 추가
                </Button>
              </div>
            </Content>
          </Col>
          <Col x={18}>
            <Content maxWidth={'100%'} padding={10}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 10,
                }}
              >
                <h4 style={{ ...styles.tabTitle }}>직원정보</h4>
                <Button
                  type="primary"
                  style={{ background: 'var(--primary-color)' }}
                >
                  편집
                </Button>
              </div>
              <Descriptions
                align="left"
                items={[
                  {
                    key: `3`,
                    label: '직원명',
                    children: '곽필두',
                  },
                  {
                    key: `4`,
                    label: '직원번호',
                    children: '0000000000',
                  },
                  {
                    key: `5`,
                    label: '생년월일',
                    children: moment().format('YYYY.MM.DD'),
                  },
                  {
                    key: `6`,
                    label: '대표자',
                    children: '홍길동',
                  },
                  {
                    key: `7`,
                    label: '프로필 이미지',
                    children: <Button>+ 추가</Button>,
                    span: 2,
                  },
                  {
                    key: `8`,
                    label: '담당업무',
                    children: '매니저/바리스타',
                    span: 2,
                  },
                  {
                    key: `9`,
                    label: '근무시간',
                    children: (
                      <>
                        <HtmlContent
                          content={`<p>월: 10:00~21:00</p><p>화: 10:00~21:00</p><p>수: 10:00~21:00</p><p>목: 10:00~21:00</p><p>금: 10:00~24:00</p><p>토/일: 10:00~24:00</p><p>공휴일: 10:00~21:00</p>`}
                          style={{ textAlign: 'left', padding: '20px 0' }}
                        />
                      </>
                    ),
                  },
                ]}
              />
            </Content>
          </Col>
        </Row>
      ),
    };

    return view[tabKey];
  };

  useEffect(() => {
    renderTabView();
    // eslint-disable-next-line
  }, [tabKey]);

  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>매장 관리</Title>

          <Row gutter={[1, 1]}>
            {/* 매장목록 */}
            <Col x={4}>
              <Content maxWidth={'100%'} padding={0} style={{ height: '100%' }}>
                <Content
                  maxWidth={'100%'}
                  padding={5}
                  style={{ borderBottom: '1px solid #EBEBEB' }}
                >
                  <Input placeholder="매장명을 입력해주세요" />
                </Content>

                <Content maxWidth={'100%'} padding={10}>
                  <TabMenu
                    items={tabItems}
                    activeKey={selectedStore.key}
                    onChange={(e) => setSelectedStore(e)}
                  />
                </Content>
              </Content>
            </Col>
            {/* 매장목록 끝 */}

            {/* 매장 설정 */}
            <Col x={20}>
              <Content maxWidth={'100%'} padding={0} style={{ height: '100%' }}>
                <div style={{ position: 'relative', top: 0, left: 0 }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      position: 'absolute',
                      top: '50%',
                      left: 20,
                      transform: 'translate(0, -50%)',
                    }}
                  >
                    <Avatar size={32} shape="square" />
                    <h2
                      style={{
                        fontSize: 18,
                        fontWeight: 700,
                        color: '#242424',
                        lineHeight: '133%',
                        marginLeft: 10,
                      }}
                    >
                      {selectedStore.label}
                    </h2>
                  </div>
                  <div style={{ paddingTop: 8 }}>
                    <Tabs
                      items={[
                        { label: '판매현황', key: 1 },
                        { label: '지점현황', key: 2 },
                        { label: '메뉴관리', key: 3 },
                        { label: '직원관리', key: 4 },
                      ]}
                      position="center"
                      activeKey={tabKey}
                      onChange={(e) => setTabKey(e)}
                    />
                  </div>
                </div>

                <div>{renderTabView()}</div>
              </Content>
            </Col>
            {/* 매장 설정 끝 */}
          </Row>
        </Col>
      </Row>
    </Content>
  );
};

export default StoreListPresenter;
